import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ButtonInput from '../button-input/ButtonInput';
import SelectBox from '../select-box/SelectBox';
import TextInput from '../text-input/TextInput';
import { Grid, GridItem } from '../grid/Grid';
import './DateRangeFilterInput.css';

export default class DateRangeFilterInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      existingContentObject: (this.props.existingContentObject) ? this.props.existingContentObject : {}
    };
  }

  componentWillReceiveProps(newProps) {
    // For case where user is going from edit-mode to read-only-mode (like onCancel)
    if (newProps.existingContentObject !== this.props.existingContentObject &&
      this.props.isEditable && !newProps.isEditable) {
      this.setState({ existingContentObject: newProps.existingContentObject });
    }
  }

  // Grabs the values from the inputs and updates the state with the new values
  getValue = () => {
    let newDateRangeObject = {};

    newDateRangeObject["dateField"] = this[`${this.props.id}__date-field`].getValue();
    newDateRangeObject["dateFrom"] = this[`${this.props.id}__date-from`].getValue();
    newDateRangeObject["dateTo"] = this[`${this.props.id}__date-to`].getValue();

    this.setState({ existingContentObject: newDateRangeObject });

    return newDateRangeObject;
  }

  render () {
    const label = (this.props.label) ?
      <label htmlFor={this.props.id}>
        {this.props.label}
      </label> :
      null;

    // Shows inputs when in edit mode, and read only versions of inputs if showInputsInReadOnly is true
    let inputDisplay = (this.props.isEditable || this.props.showInputsInReadOnly) ?
      <span>
        <SelectBox
          existingContent={this.state.existingContentObject["dateField"]}
          id={`${this.props.id}__date-field`}
          label={this.props.label}
          options={this.props.options}
          ref={instance => { this[`${this.props.id}__date-field`] = instance; }}
          className="field__full-width"
          verticalSpacing={this.props.verticalSpacing}
        />
        <Grid columns={2} isNestedGrid={true} >
          <GridItem>
            <TextInput
              id={`${this.props.id}__date-from`}
              type="date"
              label="From"
              className="field__large"
              disabled={this.props.disabled}
              existingContent={this.state.existingContentObject["dateFrom"]}
              isEditable={(!this.props.isEditable) ? false : undefined}
              ref={instance => { this[`${this.props.id}__date-from`] = instance; }}
              verticalSpacing={this.props.verticalSpacing}
            />
          </GridItem>
          <GridItem>
            <TextInput
              id={`${this.props.id}__date-to`}
              type="date"
              label="To"
              className="field__large"
              disabled={this.props.disabled}
              existingContent={this.state.existingContentObject["dateTo"]}
              isEditable={(!this.props.isEditable) ? false : undefined}
              ref={instance => { this[`${this.props.id}__date-to`] = instance; }}
              verticalSpacing={this.props.verticalSpacing}
            />
          </GridItem>
        </Grid>
        <ButtonInput
          className="button--text"
          value="Apply Date Range"
          onClick={() => {
            let val = this.getValue();
            this.props.filterValueChange(val) }}
          verticalSpacing={this.props.verticalSpacing}
        />
      </span> :
      null;

    return (
      <span className="date-range-filter-input">
        {label}
        {inputDisplay}
      </span>
    );
  }
}

DateRangeFilterInput.defaultProps = {
  isEditable: true,
  showInputsInReadOnly: false
};

DateRangeFilterInput.propTypes = {
  disabled: PropTypes.bool,
  existingContentObject: PropTypes.shape({
    dateField: PropTypes.string,
    dateFrom: PropTypes.string,
    dateTo: PropTypes.string
  }),
  id: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  label: PropTypes.string,
  showInputsInReadOnly: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/shared/components/presentation/date-range-filter-input/DateRangeFilterInput.js